import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
const sinItems = ['3 a 5 horas semanales planificando desde cero', 'Siempre los mismos ejercicios → los alumnos se aburren y abandonan', 'Alumnos que dejan sin saber por qué', 'Sin progresión clara de nivel en nivel', 'Alumno con dificultad = pánico o improvisación', 'Niveles mezclados = caos de clase permanente', 'Sin sistema de seguimiento claro ni evaluación', 'Sin identidad profesional visible ni justificada', 'Clases improvisadas = riesgo de lesiones evitables'];
const conItems = ['10 minutos por semana. El resto es estar en pista con tus alumnos', '60+ clases distintas por nivel → siempre hay algo nuevo para dar', 'Sistema de progresión → retención visible desde el primer mes', '6 tomos con progresión anual completa → mejoran y se quedan', 'Fichas técnicas con correcciones → actuás con confianza y criterio', 'Variaciones por nivel → todos mejoran juntos en la misma clase', 'Planillas y rúbricas listas para evaluar con criterio profesional', 'Sistema que justifica cobrar lo que merecés', 'Protocolos de seguridad → cero improvisación ante cualquier situación'];
export function Comparison() {
  return <Section className="bg-white" data-id="element-46">
      <div className="text-center mb-8 md:mb-16" data-id="element-47">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4 text-brand-dark" data-id="element-48">
          ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
        <div className="w-16 md:w-24 h-1 bg-brand-accent mx-auto rounded-full mt-4 md:mt-6" data-id="element-49"></div>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-50">
        {/* SIN */}
        <div className="bg-rose-50 rounded-xl md:rounded-2xl p-5 md:p-8 border border-rose-100" data-id="element-51">
          <h3 className="text-base md:text-xl font-bold text-rose-900 mb-4 md:mb-6 flex items-center justify-center border-b border-rose-200 pb-3 md:pb-4" data-id="element-52">
            SIN Patinaje Artístico Resuelto:
          </h3>
          <ul className="space-y-3 md:space-y-5" data-id="element-53">
            {sinItems.map((item, i) => <li key={i} className="flex items-start" data-id="element-54">
                <div className="bg-rose-200 rounded-full p-0.5 md:p-1 mr-2 md:mr-3 flex-shrink-0 mt-0.5" data-id="element-55">
                  <X className="w-3 h-3 md:w-4 md:h-4 text-rose-700" data-id="element-56" />
                </div>
                <span className="text-xs md:text-base text-rose-900/80" data-id="element-57">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* CON */}
        <div className="bg-emerald-50 rounded-xl md:rounded-2xl p-5 md:p-8 border border-emerald-100 shadow-lg relative" data-id="element-58">
          <div className="absolute -top-3 -right-2 md:-top-4 md:-right-4 bg-brand-accent text-brand-dark font-bold px-3 md:px-4 py-0.5 md:py-1 rounded-full text-xs md:text-sm shadow-md transform rotate-3" data-id="element-59">
            Tu nueva realidad
          </div>
          <h3 className="text-base md:text-xl font-bold text-emerald-900 mb-4 md:mb-6 flex items-center justify-center border-b border-emerald-200 pb-3 md:pb-4" data-id="element-60">
            CON Patinaje Artístico Resuelto:
          </h3>
          <ul className="space-y-3 md:space-y-5" data-id="element-61">
            {conItems.map((item, i) => <li key={i} className="flex items-start" data-id="element-62">
                <div className="bg-emerald-500 rounded-full p-0.5 md:p-1 mr-2 md:mr-3 flex-shrink-0 mt-0.5" data-id="element-63">
                  <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-64" />
                </div>
                <span className="text-xs md:text-base text-emerald-900 font-medium" data-id="element-65">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}